import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MpsAuditService } from '../services/mps-audit.service';

/**
 * Injects MpsAudit context headers on every outbound HTTP request:
 *   - mpsaudit-page-name   : current page (defaults to window.location.pathname)
 *   - mpsaudit-user-action : current action tag (set via MpsAuditService.setCurrentAction)
 *
 * The back-end middleware reads these headers in `MpsAuditService::onNewRequest`.
 */
@Injectable()
export class MpsAuditInterceptor implements HttpInterceptor {
  constructor(private auditService: MpsAuditService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const page = this.auditService.getCurrentPage();
    const action = this.auditService.getCurrentAction();

    const authReq = req.clone({
      setHeaders: {
        'mpsaudit-page-name': page,
        'mpsaudit-user-action': action,
      },
    });

    return next.handle(authReq);
  }
}
